var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReduceDelete = function SvgIconReduceDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 6.25H5v10h10zM3.75 5v11.25c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V5z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 1.25,
    x: 2.5,
    y: 5,
    fill: "currentColor",
    rx: 0.625
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1.25,
    x: 7.5,
    y: 2.5,
    fill: "currentColor",
    rx: 0.625
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1.25,
    x: 8.75,
    y: 8.75,
    fill: "currentColor",
    rx: 0.625,
    transform: "rotate(90 8.75 8.75)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1.25,
    x: 12.5,
    y: 8.75,
    fill: "currentColor",
    rx: 0.625,
    transform: "rotate(90 12.5 8.75)"
  })));
};
export default SvgIconReduceDelete;